import { IBuilder, Builder } from 'builder-pattern';
import { GenderEnum, OnlineStatusEnum } from 'src/app/core/enums';
import { Avatar3DInterface } from '../avatar-3d/avatar-3d.interface';

// local placeholder: no request to a third-party avatar service
function getDefaultProfilePicture(): string {
  return '/assets/images/icons/avatar-placeholder.svg';
}

export interface PlayerInterface {
  userID?: number;
  gender?: GenderEnum;
  username?: string;
  points?: number;
  profilePicture?: string;
  smallProfilePicture?: string;
  isFriend?: boolean;
  isEnemy?: boolean;
  isAdministrator?: boolean;
  avatar3d?: Avatar3DInterface;
  onlineStatus?: OnlineStatusEnum; // FE-only
  isNPC?: boolean; //set ONLY in FE for training games
  wantToLeaveAfterBummerl?: boolean | Date; // Server-side status for wanting to leave after bummerl
  premiumBadge?: boolean; // Stammtisch-Abo subscriber with badge enabled — render the Stammgast crown
  isGuest?: boolean; // guest account — omitted by the backend for registered users (see isGuestPlayer() fallback)
  drink?: string; // premium cosmetic, omitted by backend when 'none'/non-premium
  tableTexture?: string; // premium cosmetic, omitted by backend when default/non-premium
}

export namespace PlayerInterface {
  export function builder(
    template?: Partial<PlayerInterface>
  ): IBuilder<PlayerInterface> {
    return Builder<PlayerInterface>(template)
      .profilePicture(template?.profilePicture ?? getDefaultProfilePicture())
      .isFriend(template?.isFriend ?? false)
      .isEnemy(template?.isEnemy ?? false)
      .isAdministrator(template?.isAdministrator ?? false);
  }
}

export interface MyPlayerInterface extends PlayerInterface {
  tableID: number;
  watchingTableID: number;
  table: any;
  isInMatchmaking?: boolean;
}

export namespace MyPlayerInterface {
  export function builder(
    template?: Partial<MyPlayerInterface>
  ): IBuilder<MyPlayerInterface> {
    return Builder<MyPlayerInterface>(template);
  }
}
